import { BaseAjaxForm } from "mixs/base/form_ajax_mixin";
import { VALID_USER }   from "apps/action_types";
import { validations }  from "apps/actions/validations";
import { save }         from "apps/actions/common";
import serializeJSON     from 'utilities/serialize_json';
import {
  GOTO_COMMENT_FORM,
  APPROVAL_CLICK_REQUIRE
} from 'apps/events';
import RiotEventManager   from 'utilities/riot/event_manager';
import jump from 'jump.js';
class FormSave extends BaseAjaxForm {
  eventManager: RiotEventManager;
  validFunction = validations.comment;
  submitFunction = save;
  textArea: HTMLTextAreaElement;
  init(){
    super.init();
    this.watch();
    let onSelectedTask = (newVal: any, oldVal: any, objectPath: string) => { this.onSelectTask(newVal, oldVal, objectPath); }
    this.watchData('data.orders_planner.selectedTask', onSelectedTask);
    this.eventManager = new RiotEventManager(this)
    this.eventManager.customEvent(GOTO_COMMENT_FORM, (e) => {this.gotoCommentForm(e)})
    this.eventManager.customEvent(APPROVAL_CLICK_REQUIRE, (e) => {this.focusCommentForm(e)});
    this.listenMount([this.onMountFormSave]);
  }
  onMountFormSave(){
    this.textArea = this.querySelector('textarea') as HTMLTextAreaElement;
  }
  onSelectTask(selectedTask: any, oldVal: any, objectPath: string){
    let newVal = {
      inputs: { to_whom: {
        colorcode: '',
        taskId: null,
        phaseName: '',
        useTaskId: false
      }}
    }
    if(selectedTask){
      newVal = {
        inputs: { to_whom: {
          colorcode: selectedTask.phaseData().colorcode,
          taskId: selectedTask.taskId,
          phaseName: selectedTask.phaseData().name,
          useTaskId: true
        }}
      }
    }
    this.dispatch(newVal);
  }
  gotoCommentForm(e){
    jump(this.rootElement(),{
      duration: 500,
      offset: -80
    })
  }
  focusCommentForm(e){
    this.textArea.focus();
  }
}
riot.mixin('forms.comments.save', FormSave as riot.TagMixin)
